/**
 * This should not be treated as a fact we are attempting
 * to match as many responses with acceptable use warnings
 * however, we may get false positives or false negatives
 *
 * TODO POST EAP
 * Modify this when the backend is able to return
 * acceptable-use-warning flags to the frontend
 *
 * @markdown string to check for acceptable use warning
 * @returns boolean | undefined if the users locale is not english
 */
export var getHasAcceptableUseWarning = function getHasAcceptableUseWarning(_ref) {
  var _ref$markdown = _ref.markdown,
    markdown = _ref$markdown === void 0 ? '' : _ref$markdown,
    locale = _ref.locale;
  var isEnglishLocale = locale.startsWith('en');
  if (!isEnglishLocale) {
    return;
  }
  var markdownLowercase = markdown.toLowerCase();
  return getHasSearchString(markdownLowercase);
};
var getHasSearchString = function getHasSearchString(stringToSearch) {
  var acceptableUsePolicySearchStrings = ["i'm sorry, but i can't fulfil", "i'm sorry, but i cannot fulfil", "i am sorry, but i can't fulfil", 'i am sorry, but i cannot fulfil', "atlassian's acceptable use", 'i apologise, but i cannot fulfil', "i apologise, but i can't fulfil", 'i apologize, but i cannot fulfil', "i apologize, but i can't fulfil"];
  var hasSearchString = acceptableUsePolicySearchStrings.some(function (searchString) {
    return stringToSearch.includes(searchString);
  });
  return hasSearchString;
};